'use client'

import type { PublicHeaderBarProps } from '@/components/public-header-bar/public-header-bar.types'

import { Logo } from '@maestro/commerce-blocks/components/logo'

import '@/components/public-header-bar/styles/public-header-bar.scss'

export default function PublicHeaderBar(props: PublicHeaderBarProps) {
  const { logoDestination } = props

  return (
    <header className="public-header-bar desktop-only">
      <div className="public-header-bar__logo">
        <Logo source="/assets/logo.svg" destination={logoDestination} />
      </div>
    </header>
  )
}
